import Select from '../DefaultSelect';
import { TSelectProps } from '../index';
import { mergeSX } from '../../../services/helpers';
import { AB2, S1 } from '../../../theme';
import { TYPOGRAPHY_BODY2 } from '../../Typography';

const buildSX = () => ({
  '&.MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    height: '48px',
    color: S1,
    '&:hover': {
      backgroundColor: AB2,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${AB2}`,
    borderRight: 'transparent',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${AB2}`,
    borderRight: 'transparent',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${AB2}`,
    borderRight: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    color: S1,
  },
  '& .MuiSelect-select': {
    ...TYPOGRAPHY_BODY2,
    paddingLeft: '16px',
  },
});

const SideMenuSelect = (props: TSelectProps) => {
  const { children, sx, ...restProps } = props;

  return (
    <Select sx={mergeSX(buildSX(), sx)} {...restProps}>
      {children}
    </Select>
  );
};

export default SideMenuSelect;
